import {
  AutomationActionType
  // RequirementConditionType
} from 'services/automation/types';
import { AutomationFormItem } from '../types';
import { ConversationStatus } from 'generated-graphql/types';

export const getDefaultValue = ({
  conversationStatusAvailableOptions,
  actionOptionsAvailable
}: {
  conversationStatusAvailableOptions: ConversationStatus[];
  actionOptionsAvailable: AutomationActionType[];
}): AutomationFormItem => {
  return {
    requirementConditions: [
      {
        type: undefined,
        conversationStatus: conversationStatusAvailableOptions[0]
      }
    ],
    action: {
      type: actionOptionsAvailable[0]
    }
  };
};
